import 'css-chunksrc/client/scenes/attachDocuments/sideBar/directoryStructure/styles.scss';export default {
  "header": "_header_11asw_1",
  "toggleIconBox": "_toggleIconBox_11asw_11",
  "toggleIcon": "_toggleIcon_11asw_11",
  "icon": "_icon_11asw_21",
  "name": "_name_11asw_26",
  "children": "_children_11asw_33",
  "root": "_root_11asw_37",
  "open": "_open_11asw_42",
  "selected": "_selected_11asw_46"
};